export default "__VITE_ASSET__Ct3Vu6pa__"